export default __webpack_public_path__ + "static/media/in-call.74f0df0a.gif";